<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-title" style="margin-left:0rem;">
                            为加快我市博士后工作创新发展，吸引集聚青年科技人才，按照“人才新政3.0版”，对符合条件的博士后人才发放生活资助及项目资助。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/20/label1.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        在站（在蓉的博士后科研流动站、博士后科研工作站和博士后创新实践基地）从事博士后研究工作的人才。
                    </div>
                </div>
            </div>
            <div class="part-three-extra">
                <img src="../assets/imgs/22/part-3-title.png" class="part-two-title-img" />
                <div class="main-content" style="margin-top: 0.4rem">
                    <div class="part-four-title">一. 博士后生活资助</div>
                    <div class="part-four-items">
                        2022年7月后新进入博士后科研流动站、工作站或创新实践基地的全职博士后人员，在站期间每人每年可申请10万元生活资助，连续资助期不超过2年;在职博士后人员，在站期间每人每年可申请5万元生活资助，连续资助期不超过2年。
                    </div>
                </div>
                <div class="main-content">
                    <div class="part-four-title">二. “博新计划”项目资助</div>
                    <div class="part-four-items">
                        2022年7月后新入选“国家博士后创新人才支持计划”或“四川省博士后创新人才支持项目”并在蓉工作的博士后人才，每人每年可申请20万元的资助，连续资助期不超过2年。
                    </div>
                </div>
                <!-- <div style="
                            color: #3d5aa3ff;
                            font-size: 0.26rem;
                            text-align: left;
                            line-height: 1.5;
                            margin-top: 0.25rem;
                        ">
                    注：博士后人才生活资助与急需紧缺专业技术人才安家补贴、急需紧缺技能人才安家补贴、优秀海外高校毕业生创新创业补贴等政策均不能重复享受。
                </div> -->
            </div>
            <div class="part-four">
                <img src="../assets/imgs/20/label3.png" class="part-two-title-img" />
                    符合条件的人才，可通过设站单位申报。
            </div>
            <div class="part-four">
                <img src="../assets/imgs/20/label4.png" class="part-two-title-img" />
                    按照每年度通知时间确定。
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/20/label5.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>

                            <a href="tel:028-61888121">028-61888121</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局专业技术人员服务管理处
                    </div>
                </div>
            </div>
        </div>
        <call phone="028-61888121"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {}
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        min-height: 6.7rem;
        box-sizing: border-box;
        padding-bottom: 0.3rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            min-height: 5.6rem;
            background: url(../assets/imgs/20/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.2rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        display: inline-block;
        position: relative;

        .part-two-content {
            margin-top: 1.2rem;
            width: 100%;
            padding: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;
        }
    }

    .part-three {
        width: 6.85rem;
        background: #fff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-three-extra {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .main-content {
            margin-top: 0.8rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;
            position: relative;
            // margin-bottom: 0.8rem;

            .part-four-title {
                text-align: left;
                position: absolute;
                top: 0;
                left: 50%;
                font-size: 0.32rem;
                background-color: #739bfeff;
                color: #fff;
                border-radius: 20px;
                padding: 0.18rem 0.2rem;
                transform: translate(-50%, -50%);
                white-space: nowrap;
            }

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #fff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.4rem 0.25rem 0.35rem 0.25rem;
        font-size: 0.26rem;
        color:#4e4e4e;
        text-align: left;
    }

    .part-five {
        margin: auto;
        margin-top: 0.25rem;
        width: 6.86rem;
        box-sizing: border-box;
        border-radius: 13px;
        margin-bottom: 0.32rem;
        background-color: #fff;
        padding: 0.35rem;
        text-align: left;

        // img {
        //     // width: 100%;
        // }

        p {
            font-size: 0.26rem;
            color: #4e4e4eff;
        }

        a {
            font-size: 0.26rem;
            word-break: break-word;
            line-height: 1.5;
            display: inline-block;
        }
    }

    .bottom-info {
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;
    }
}
</style>
